import PageLoader from '../components/PageLoader/PageLoader';
import { getCookies, removeCookies } from '../hooks/useCookies';
import Innerlayout from '../layouts/innerLayout';
import Outerlayout from '../layouts/outerLayout';
import PageNotFound from '../pages/404/pageNotFound';
import PermissionDenied from '../pages/permission/permission';
import ProfileLayout from '../pages/profile/profileLayout';
import SettingsApi from '../pages/settings/SettingsApiPage';
import Preferences from '../pages/settings/preferences';
import Settings from '../pages/settings/settings';
import ShowsIndex from '../pages/shows';
import ShowsViewEvent from '../pages/shows/viewEvent';
import ViewShowAttendees from '../pages/shows/viewShowAttendees';
import ViewTicket from '../pages/shows/viewTicket';
import { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

const ShowDetails = lazy(() => import('../pages/show-details'));
const EventHome = lazy(() => import('../pages/dashboard/dashboardEvent'));
const Home = lazy(() => import('../pages/dashboard/dashboard'));
const ManagerIndex = lazy(() => import('../pages/managers'));
const VendorUserIndex = lazy(() => import('../pages/vendor-users'));
const AttendeeIndex = lazy(() => import('../pages/attendees'));
const ViewManager = lazy(() => import('../pages/managers/viewEvent'));
const ViewVendorUser = lazy(() => import('../pages/vendor-users/viewVendor'));
const ViewAttendee = lazy(() => import('../pages/attendees/viewEvent'));
const SettingsLayout = lazy(() => import('../pages/settings/settingsLayout'));
const DashboardViewVendor = lazy(() => import('../pages/dashboard/viewVendor'));
const ViewAppUpdate = lazy(() => import('../pages/appUpdate/viewAppUpdate'));
const AppUpdateEdit = lazy(() => import('../pages/appUpdate/editAppUpdate'));
const AppUpdateCreate = lazy(() => import('../pages/appUpdate/createAppUpdate'));
const AppUpdateIndex = lazy(() => import('../pages/appUpdate'));
const SupportIndex = lazy(() => import('../pages/support'));
const ViewSupport = lazy(() => import('../pages/support/viewSupport'));
const CmsIndex = lazy(() => import('../pages/cms'));
const CmsCreate = lazy(() => import('../pages/cms/createCms'));
const CmsEdit = lazy(() => import('../pages/cms/editCms'));
const ViewCms = lazy(() => import('../pages/cms/viewCms'));

const Login = lazy(() => import('../pages/logIn/logIn'));
const UserVerification = lazy(() => import('../pages/verify/userVerfication'));
const Forgetpassword = lazy(() => import('../pages/passwords/forgetPassword'));
const ResetPassword = lazy(() => import('../pages/passwords/resetPassword'));
// const Dashboard = lazy(() => import('../pages/dashboard/dashboard'));
const HooksTest = lazy(() => import('../components/hooksFormTest'));
const CustomHooksTest = lazy(() => import('../hooks/customHooksTest'));
const MyForm = lazy(() => import('../components/PhoneNumberBox/PhoneNumberBox'));
const AgGridTable = lazy(() => import('../components/AgTable/AgGridTable'));
// const PageNotFound = lazy(() => import('../pages/404/pageNotFound'));
const ProfilePage = lazy(() => import('../pages/profile/profilepage'));
const ChangePassword = lazy(() => import('../pages/profile/changePassword'));
const ProfileEdit = lazy(() => import('../pages/profile/profileEdits'));
const Faq = lazy(() => import('../cms/faq'));
const DesignerMode = lazy(() => import('../pages/r&d/seatMap'));
const UserMode = lazy(() => import('../pages/r&d/usermode'));

// Superadmin pages
const EventApprovalsIndex = lazy(() => import('../pages/superadmin/event-approvals'));
const EventApprovalsView = lazy(() => import('../pages/superadmin/event-approvals/view'));
const ManagerProfilesIndex = lazy(() => import('../pages/superadmin/manager-profiles'));
const ManagerProfilesAddManagerDetails = lazy(() =>
  import('../pages/superadmin/manager-profiles/add-manager-details')
);
const ManagerProfilesAddBusiness = lazy(() =>
  import('../pages/superadmin/manager-profiles/add-business')
);
const ManagerProfilesAddBusinessInfo = lazy(() =>
  import('../pages/superadmin/manager-profiles/add-businessinfo')
);
const ManagerProfilesPaymentSetup = lazy(() =>
  import('../pages/superadmin/manager-profiles/payment-setup')
);
const ManagerProfilesVerifyIdentity = lazy(() =>
  import('../pages/superadmin/manager-profiles/verify-identity')
);
const ManagerProfilesPreview = lazy(() => import('../pages/superadmin/manager-profiles/preview'));
const ManagerProfilesView = lazy(() => import('../pages/superadmin/manager-profiles/view'));
const TicketPricingAudit = lazy(() => import('../pages/superadmin/ticket-pricing-audit'));
const RefundRequests = lazy(() => import('../pages/superadmin/refund-requests'));
const PlatformAnalytics = lazy(() => import('../pages/superadmin/platform-analytics'));
const AuditLogs = lazy(() => import('../pages/superadmin/audit-logs'));

export default function Routers() {
  return (
    <Router>
      <Routes>
        <Route element={<Outerlayout />}>
          <Route
            exact
            path="/"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <UnProtectedRoute>
                  {' '}
                  <Login />
                </UnProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/login"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <UnProtectedRoute>
                  {' '}
                  <Login />
                </UnProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/designer"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <UnProtectedRoute>
                  {' '}
                  <DesignerMode />
                </UnProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/usermode"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <UnProtectedRoute>
                  {' '}
                  <UserMode />
                </UnProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/verify-email"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <UnProtectedRoute>
                  {' '}
                  <UserVerification />
                </UnProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/forgetpassword"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <UnProtectedRoute>
                  <Forgetpassword />
                </UnProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/reset"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <UnProtectedRoute>
                  {' '}
                  <ResetPassword />
                </UnProtectedRoute>
              </Suspense>
            }
          />
          {/* <Route exact path="/" element={<Dashboard />} /> */}
          <Route
            exact
            path="/reset"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <UnProtectedRoute>
                  {' '}
                  <ResetPassword />
                </UnProtectedRoute>
              </Suspense>
            }
          />
        </Route>
        <Route element={<Innerlayout />}>
          <Route
            exact
            path="/eventdashboard"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <ProtectedRoute>
                  {' '}
                  <EventHome />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/dashboard"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <ProtectedRoute>
                  {' '}
                  <Home />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/manager"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <ProtectedRoute>
                  {' '}
                  <ManagerIndex />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/support"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <ProtectedRoute>
                  {' '}
                  <SupportIndex />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/support/viewdetails/:supportId"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <ProtectedRoute>
                  {' '}
                  <ViewSupport />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/manager/viewdetails/:managerId"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <ProtectedRoute>
                  {' '}
                  <ViewManager />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/vendorusers"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <ProtectedRoute>
                  {' '}
                  <VendorUserIndex />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/vendorusers/viewdetails/:vendorId"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <ProtectedRoute>
                  {' '}
                  <ViewVendorUser />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/attendee"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <ProtectedRoute>
                  {' '}
                  <AttendeeIndex />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/attendee/viewdetails/:userId"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <ProtectedRoute>
                  {' '}
                  <ViewAttendee />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/hooks"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <ProtectedRoute>
                  {' '}
                  <HooksTest />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/customhooks"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <ProtectedRoute>
                  {' '}
                  <CustomHooksTest />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/text"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <ProtectedRoute>
                  {' '}
                  <MyForm />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/table"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <ProtectedRoute>
                  {' '}
                  <AgGridTable />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/eventdashboard/vendor/:vendorId"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <ProtectedRoute>
                  {' '}
                  <DashboardViewVendor />
                </ProtectedRoute>
              </Suspense>
            }
          />

          <Route
            exact
            path="/appupdate"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <ProtectedRoute>
                  {' '}
                  <AppUpdateIndex />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/shows"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <ProtectedRoute>
                  {' '}
                  <ShowsIndex />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/shows/view-users/:eventId"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <ProtectedRoute>
                  {' '}
                  <ViewShowAttendees />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/shows/view-event/:eventId"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <ProtectedRoute>
                  {' '}
                  <ShowsViewEvent />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/shows/view-ticket/:ticketId"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <ProtectedRoute>
                  {' '}
                  <ViewTicket />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/appupdate/create"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <ProtectedRoute>
                  {' '}
                  <AppUpdateCreate />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            path="/appupdate/edit/:appId"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <ProtectedRoute>
                  {' '}
                  <AppUpdateEdit />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/appupdate/viewdetails/:appId"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <ProtectedRoute>
                  {' '}
                  <ViewAppUpdate />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/cms"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <ProtectedRoute>
                  {' '}
                  <CmsIndex />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/cms/create"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <ProtectedRoute>
                  {' '}
                  <CmsCreate />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            path="/cms/edit/:cmsId"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <ProtectedRoute>
                  {' '}
                  <CmsEdit />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/cms/viewdetails/:cmsId"
            element={
              <Suspense fallback={<PageLoader fullPage />}>
                <ProtectedRoute>
                  {' '}
                  <ViewCms />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route element={<SettingsLayout />}>
            <Route
              exact
              path="/settings"
              element={
                <Suspense fallback={<PageLoader fullPage />}>
                  <ProtectedRoute>
                    {' '}
                    <Settings />
                  </ProtectedRoute>
                </Suspense>
              }
            />
            <Route
              exact
              path="/preferences"
              element={
                <Suspense fallback={<PageLoader fullPage />}>
                  <ProtectedRoute>
                    {' '}
                    <Preferences />
                  </ProtectedRoute>
                </Suspense>
              }
            />
            <Route
              exact
              path="/api"
              element={
                <Suspense fallback={<PageLoader fullPage />}>
                  <ProtectedRoute>
                    {' '}
                    <SettingsApi />
                  </ProtectedRoute>
                </Suspense>
              }
            />
          </Route>
          <Route element={<ProfileLayout />}>
            <Route
              exact
              path="/profile"
              element={
                <Suspense fallback={<PageLoader fullPage />}>
                  <ProtectedRoute>
                    {' '}
                    <ProfilePage />
                  </ProtectedRoute>
                </Suspense>
              }
            />
            <Route
              exact
              path="/profile-edit"
              element={
                <Suspense fallback={<PageLoader fullPage />}>
                  <ProtectedRoute>
                    {' '}
                    <ProfileEdit />
                  </ProtectedRoute>
                </Suspense>
              }
            />
            <Route
              exact
              path="/cms"
              element={
                <Suspense fallback={<PageLoader fullPage />}>
                  <ProtectedRoute>
                    {' '}
                    <Faq />
                  </ProtectedRoute>
                </Suspense>
              }
            />

            <Route
              exact
              path="/changePassword"
              element={
                <Suspense fallback={<PageLoader fullPage />}>
                  <ProtectedRoute>
                    {' '}
                    <ChangePassword />
                  </ProtectedRoute>
                </Suspense>
              }
            />
          </Route>
          {/* Superadmin Routes */}
          <Route
            exact
            path="/event-approvals"
            element={
              <Suspense fallback={null}>
                <ProtectedRoute>
                  {' '}
                  <EventApprovalsIndex />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/event-approvals/view"
            element={
              <Suspense fallback={null}>
                <ProtectedRoute>
                  {' '}
                  <EventApprovalsView />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/manager-profiles"
            element={
              <Suspense fallback={null}>
                <ProtectedRoute>
                  {' '}
                  <ManagerProfilesIndex />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/manager-profiles/add-manager-details"
            element={
              <Suspense fallback={null}>
                <ProtectedRoute>
                  {' '}
                  <ManagerProfilesAddManagerDetails />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/manager-profiles/add-business"
            element={
              <Suspense fallback={null}>
                <ProtectedRoute>
                  {' '}
                  <ManagerProfilesAddBusiness />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/manager-profiles/add-businessinfo"
            element={
              <Suspense fallback={null}>
                <ProtectedRoute>
                  {' '}
                  <ManagerProfilesAddBusinessInfo />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/manager-profiles/payment-setup"
            element={
              <Suspense fallback={null}>
                <ProtectedRoute>
                  {' '}
                  <ManagerProfilesPaymentSetup />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/manager-profiles/verify-identity"
            element={
              <Suspense fallback={null}>
                <ProtectedRoute>
                  {' '}
                  <ManagerProfilesVerifyIdentity />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/manager-profiles/preview"
            element={
              <Suspense fallback={null}>
                <ProtectedRoute>
                  {' '}
                  <ManagerProfilesPreview />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/manager-profiles/view/:managerId"
            element={
              <Suspense fallback={null}>
                <ProtectedRoute>
                  {' '}
                  <ManagerProfilesView />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/ticket-pricing-audit"
            element={
              <Suspense fallback={null}>
                <ProtectedRoute>
                  {' '}
                  <TicketPricingAudit />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/refund-requests"
            element={
              <Suspense fallback={null}>
                <ProtectedRoute>
                  {' '}
                  <RefundRequests />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/platform-analytics"
            element={
              <Suspense fallback={null}>
                <ProtectedRoute>
                  {' '}
                  <PlatformAnalytics />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/audit-logs"
            element={
              <Suspense fallback={null}>
                <ProtectedRoute>
                  {' '}
                  <AuditLogs />
                </ProtectedRoute>
              </Suspense>
            }
          />
        </Route>
        <Route
          exact
          path="/show-details/:id"
          element={
            <Suspense fallback={<PageLoader fullPage />}>
              <ProtectedRoute>
                {' '}
                <ShowDetails />
              </ProtectedRoute>
            </Suspense>
          }
        />
        <Route
          exact
          path="*"
          element={
            <Suspense fallback={<PageLoader fullPage />}>
              {' '}
              <PageNotFound />
            </Suspense>
          }
        />
        <Route
          exact
          path="/permission"
          element={
            <Suspense fallback={<PageLoader fullPage />}>
              <ProtectedRoute>
                {' '}
                <PermissionDenied />
              </ProtectedRoute>
            </Suspense>
          }
        />
      </Routes>
    </Router>
  );
}

function ProtectedRoute({ children }) {
  if (document.cookie && getCookies('Token')) {
    if (getCookies('USERPERMISSION')) {
      return children;
    }
    removeCookies('Token');
    removeCookies('refreshToken');
    sessionStorage.setItem('cookiesCleared', true);
    return <Navigate to="/login" />;
  }
  sessionStorage.setItem('cookiesCleared', true);
  return <Navigate to="/login" />;
}

function UnProtectedRoute({ children }) {
  const userType = getCookies('USERROLE');
  if (getCookies('Token')) {
    if (userType === 'manager') {
      return <Navigate to="/eventdashboard" />;
    }
    return <Navigate to="/dashboard" />;
  }
  return children;
}
